import { Select, Row, Col, Button } from "antd";
import setImageAbsoluteUrl from "../../utils/setImageAbosulteUrl";
import { useEffect, useState } from "react";
const { Option } = Select;

const PaymentMethodsSection = ({ title, methods }) => {
  return (
    <Row className="PaymentMethods-Row">
      <Col span={24}>
        <p className="PaymentMethods-type-name b4-body-500">{title}</p>
      </Col>
      <Col span={24}>
        <Row>
          <div className="PaymentMethods-grid-container">
            {methods.map((method, index) => (
              <div className="PaymentMethods-Col" key={index}>
                <img
                  loading="lazy"
                  className="PaymentMethods-logo"
                  alt={method.name}
                  src={setImageAbsoluteUrl(method.logo)}
                />
              </div>
            ))}
          </div>
        </Row>
      </Col>
    </Row>
  )
};

const parseMarketsMobile = (data, lang) => {
  return Object.entries(data).map(([region, countries]) => ({
    label: <span>{region}</span>, 
    title: region,
    options: countries.map((country) => ({
      label: (
        <span>
          {country?.nombres[lang] ? country?.nombres[lang] : country?.country}
        </span>
      ),
      value: country.slug,
    })),
  }));
};

const findCountry = (marketsData, countryName) => {
  return Object.values(marketsData)
    .flat()
    .find((country) => {      
      return country.slug === countryName
    });
};

const Mobile = ({ selectedCountry, setSelectedCountry, marketsData, paymentTypes, subtitle, lang }) => {

  const [parsedMarkets, setParsedMarkets] = useState([]);

  useEffect(() => {
    if (marketsData && Object.keys(marketsData).length > 0) {
      setParsedMarkets(parseMarketsMobile(marketsData, lang));
    }
  }, [marketsData, lang]);

  const handleChange = (value) => {
  
    const selected = parsedMarkets
    .flatMap((region) => region.options)
    .find((option) => option.value === value);
    
    setSelectedCountry(selected ? findCountry(marketsData, selected.value) : null);
  };

  const marketsDir = (lang) => {
    let dir = ''
    if (lang === 'en') {
      dir = 'markets'
    } else {
      dir = 'mercados'
    }
    return dir
  }
  const exploreTranslation = (lang) => {
    let explore = 'Explore market →'
    if (lang === 'pt') {
      explore = 'Explorar mercado →'
    } else if (lang === 'es') {
      explore = 'Explorar el mercado →'
    }
    return explore
  }
  
  return (
		<>
      <Row style={{ 
        background: '#fff', 
        padding: '0px 18px', 
        borderRadius: '24px'
      }}>
        <Row style={{ 
          paddingTop: '32px', 
          paddingBottom: '16px',
          paddingLeft: '18px',
          paddingRight: '18px' }}>
          <Col span={24}>
            <span className="b1-body-800">
              {subtitle}
            </span>
          </Col>
        </Row>
        <Row className="PaymentMethods-Header">
          <Col span={24}>
            <Select
              showSearch
              optionFilterProp="value"
              className="PaymentMethods-Dropdown bt-medium-500"
              value={selectedCountry?.slug}
              onChange={handleChange}
              options={parsedMarkets}
            />
          </Col>
        </Row>
        {selectedCountry?.showDetailLink == 'Yes' && (
          <div style={{ paddingInline: "18px" }}>
            <Button 
              className="bt-medium-500" 
              style={{color: '#0027F9' }} 
              type="link" 
              href={`/${lang}/${marketsDir(lang)}/${selectedCountry?.slug}`} 
              variant="link">
                {exploreTranslation(lang)}
            </Button>
          </div>
        )}
        <Row style={{ padding: "0px 30px", flexDirection: 'column', minHeight: '300px' }}>
          {paymentTypes.map(({ title, methods }) => {
            if (methods.length > 0)
              return (
                <PaymentMethodsSection key={title} title={title} methods={methods} />
              )
          })}
        </Row>
			</Row>
    </>
  );
};

export default Mobile;
